import React from "react";
// import CheckEmailVerification from "../components/check-email-verification/CheckEmailVerification";
// import AccountInfo from "../components/account-info/AccountInfo";
import Navbar from "../components/navbar/Navbar";
import VolatilityAnalysis from "../components/volatility-analysis/VolatilityAnalysis";
// import NavbarTabs from "../components/navbar-tabs/NavbarTabs";

// import Plot from "react-plotly.js";

function VolatilityAnalysisScreen() {
  return (
    <div className="container-fluid bg-theme vh-100 d-flex flex-column">
      <div className="w-100 flex-shrink-0">
        <Navbar />
        {/*<NavbarTabs />*/}
      </div>

      <div className="w-100 flex-grow-1 d-flex flex-column" style={{ minHeight: 0 }}>
        <VolatilityAnalysis />
      </div>
    </div>
  );
}

export default VolatilityAnalysisScreen;
